import { render, staticRenderFns } from "./account-form.vue?vue&type=template&id=0a52e9d0&scoped=true&"
import script from "./account-form.vue?vue&type=script&lang=js&"
export * from "./account-form.vue?vue&type=script&lang=js&"
import style0 from "./account-form.vue?vue&type=style&index=0&id=0a52e9d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a52e9d0",
  null
  
)

export default component.exports